import { BusinessUnitLeadMetrics } from 'services/types/metrics';

/**
 * Gets hard metrics for leads to display in metric cards
 *
 * @param {Object} props - The props object
 * @param {BusinessUnitLeadMetrics | null} props.businessUnitLeadMetrics - Lead metrics data
 * @returns {Array} Array of metric objects for display
 */
const getLeadHardMetrics = ({
  businessUnitLeadMetrics,
}: {
  businessUnitLeadMetrics: BusinessUnitLeadMetrics | null;
}) => {
  if (!businessUnitLeadMetrics) {
    return [];
  }

  return [
    {
      type: 'Total de Leads',
      data: businessUnitLeadMetrics.hardMetrics.leadsCount,
      tooltip: 'Total de leads creados en el rango de fechas seleccionado',
    },
    {
      type: 'Leads en CRM',
      data:
        (businessUnitLeadMetrics.hardMetrics.leadsUploadedToCRM || 0) /
        (businessUnitLeadMetrics.hardMetrics.leadsCount || 1),
      secondaryData: businessUnitLeadMetrics.hardMetrics.leadsUploadedToCRM,
      tooltip: 'Leads que fueron subidos al CRM (de los creados en el rango de fechas seleccionado)',
      percentage: true,
    },
  ];
};

export default getLeadHardMetrics;
